import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_RECEIPTS] (state, receiptsInfo) {
        state.receiptsInfo = receiptsInfo;
    },
    [types.SET_IS_NEW_PAYMENT_FLOW_FEATURE] (state, isNewPaymentFlowFeature) {
        state.isNewPaymentFlowFeature = isNewPaymentFlowFeature;
    },
    [types.SET_PAYNOW_RECEIPTS_PAGINATION_PARAMS] (state, paginationParams) {
        state.paynowReceiptsPaginationParams = paginationParams;
    },
    [types.SET_PAYNOW_TRANSACTION_PAGE_SIZE] (state, pageSize) {
        state.paynowTransactionPageSize = pageSize;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/receipts/mutations.js